import listSaga from './listSaga'
import staticEnumsSaga from './staticEnumsSaga'
import createSaga from './createSaga'
import editSaga from './editSaga'
import oneTemplateSaga from './oneTemplateSaga'

const templatesSagas = [listSaga(), staticEnumsSaga(), createSaga(), editSaga(), oneTemplateSaga()]

export default templatesSagas
